import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-06776c27"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 2,
  style: {
    "width": "100%"
  }
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shangchuan"
}, null, -1));

const _hoisted_5 = {
  class: "mg-l--5"
};
const _hoisted_6 = {
  key: 3,
  class: "flex_box"
};
const _hoisted_7 = {
  key: 4,
  style: {
    "height": "100%",
    "width": "100%"
  }
};
const _hoisted_8 = {
  style: {
    "height": "100%",
    "position": "relative",
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  key: 0,
  class: "add-form-btn"
};
const _hoisted_12 = {
  style: {
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_13 = ["src", "alt"];
import MultiFormTable from '@/components/MultiFormTable/index.vue';
import MultiFormItem from '@/components/MultiFormTable/MultiFormItem.vue';
import ManuallyUpload from '@/components/Upload/ManuallyUpload.vue';
import MyLoadingImage from '@/components/MyLoadingImage/index.vue';
import { isEmptyArray } from '@/utils';
import { getArrByReduce } from '@/utils/tools';
import { validateImageUrl, validateUrl } from '@/utils/validate';
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';
import PosterList from '../PosterList';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    fileType: {
      type: Array,
      default: ['png', 'jpg']
    },
    accept: {
      type: String,
      default: ".png,.jpg"
    },
    limit: {
      type: Number,
      default: 1
    },
    formData: {
      type: Array,
      default: []
    }
  },
  emits: ['update:modelValue', 'on-comfirm'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const posterObj = ref({
      visible: false,
      data: null
    });
    const uploadImgParams = inject('uploadImgParams');
    const {
      t
    } = useI18n();
    const FormRef = ref(null);

    const handleCheckChange = (val, index) => {
      formConfig.formData.uploadInfo[index].type = val;
      formConfig.formData.uploadInfo[index].url = '';
      formConfig.formData.uploadInfo[index].file = [];
      formConfig.formData.uploadInfo[index].base64Image = '';
    };

    const fileChange = (file, index) => {
      // 显示图标
      let reader = new FileReader(); //转base64

      reader.onload = function (e) {
        const res = e.target.result; //将图片路径赋值给src

        formConfig.formData.uploadInfo[index].file = [];
        formConfig.formData.uploadInfo[index].file = file;
        formConfig.formData.uploadInfo[index].base64Image = res;
        formConfig.formData.uploadInfo[index].url = ''; // FormRef.value.mForm.validateField('file');

        FormRef.value.mForm.validateField(`uploadInfo[${String(index)}].file`);
      };

      reader.readAsDataURL(file.raw);
    };

    const dialogConfig = reactive({
      visible: false,
      action: 'add',
      config: {
        title: '上传图片',
        destroyOnClose: true
      },
      confirm: done => {
        console.log(formConfig.formData.uploadInfo);
        FormRef.value.mForm.validate((valid, error) => {
          if (valid) {
            emit('on-comfirm', formConfig.formData.uploadInfo, () => closeDialog(done));
          } else {
            console.log(error);
            done();
          }
        });
      },
      cancel: () => {
        emit('update:modelValue', false);
      }
    });

    const closeDialog = done => {
      emit('update:modelValue', false);
      done();
    }; // const posterTypeList = ref([
    //     { label: t('通用'), value: 1 },
    //     { label: t('安卓'), value: 2 },
    //     { label: t('手机'), value: 3 },
    //     { label: t('横版'), value: 4 },
    //     { label: t('竖版'), value: 5 },
    // ])


    const posterTypeList = ref([{
      label: t('通用'),
      value: 'common'
    }, {
      label: t('安卓'),
      value: 'android'
    }, {
      label: t('手机'),
      value: 'mobile'
    }, {
      label: t('横版'),
      value: 'horizontal'
    }, {
      label: t('竖版'),
      value: 'vertical'
    }]);
    const selectOptions = computed(() => {
      const options = [];
      posterTypeList.value.forEach(item => {
        options.push({ ...item,
          disabled: false
        });
      });
      return options;
    }); // 已选的海报类型加上禁用

    const addDisabledForOptions = val => {
      if (!isEmptyArray(val)) {
        let ids = getArrByReduce(val, 'posterType');
        selectOptions.value.forEach(item => {
          item.disabled = ids.includes(item['value']) ? true : false;
        });
      }
    };

    const formConfig = reactive({
      formList: [[{
        label: '海报类型',
        prop: 'posterType',
        required: true,
        itemSlot: true,
        // widgetType: 'Select',
        controller: (value, data, config) => {
          return true;
        },
        style: {
          'border-right': 'none'
        },
        // list: selectOptions,
        rules: [{
          required: true,
          message: t('请选择海报类型'),
          trigger: 'change'
        }]
      }, {
        label: '',
        prop: 'uploadImage',
        itemSlot: true,
        rowspan: 4,
        tdClass: 'preview-image-warp',
        style: {
          'padding': 0,
          'background-color': '#fff',
          'border-left': '1px solid #EAEDF0'
        }
      }], [{
        label: '添加方式',
        prop: 'type',
        itemSlot: true,
        widgetType: 'input',
        controller: (value, data, config) => {
          return true;
        }
      }], [{
        label: '图片URL',
        prop: 'url',
        widgetType: 'tooltipInput',
        required: true,
        controller: (value, data, config) => {
          return data.type === 0 ? true : false;
        },
        style: {
          'border-bottom': 'none'
        },
        rules: [{
          required: true,
          validator: validateImageUrl,
          trigger: 'blur'
        }, {
          required: true,
          max: 512,
          message: t('限制字符数量', {
            num: '512'
          }),
          trigger: 'blur'
        }]
      }], [{
        label: '图片URL',
        prop: 'url',
        itemSlot: true,
        widgetType: 'tooltipInput',
        required: true,
        controller: (value, data, config) => {
          // 图库选图用此配置项
          return data.type === 2 ? true : false;
        },
        style: {
          'border-bottom': 'none'
        },
        rules: [{
          required: true,
          validator: validateImageUrl,
          trigger: 'blur'
        }, {
          required: true,
          max: 512,
          message: t('限制字符数量', {
            num: '512'
          }),
          trigger: 'blur'
        }]
      }], [{
        label: '文件',
        prop: 'file',
        itemSlot: true,
        required: true,
        widgetType: 'text',
        controller: (value, data, config) => {
          return data.type === 1 ? true : false;
        },
        rules: [{
          required: true,
          message: t('请上传文件'),
          trigger: 'change'
        }]
      }]],
      formData: {
        uploadInfo: [{
          posterType: 'common',
          type: 1,
          url: '',
          file: [],
          base64Image: ''
        }]
      },
      rules: {
        posterType: [{
          required: true,
          message: t('请选择海报类型'),
          trigger: 'change'
        }],
        url: [{
          required: true,
          validator: validateUrl,
          trigger: 'blur'
        }, {
          required: true,
          max: 512,
          message: t('限制字符数量', {
            num: '512'
          }),
          trigger: 'blur'
        }],
        file: [{
          required: true,
          message: t('请上传文件'),
          trigger: 'change'
        }]
      }
    });

    const handelRemove = (file, index) => {
      formConfig.formData.uploadInfo[index].file = []; // FormRef.value.mForm.validateField('file');

      FormRef.value.mForm.validateField(`uploadInfo[${String(index)}].file`);
    };

    const addFormItem = () => {
      let fItem = selectOptions.value.find(f => f.disabled !== true);
      formConfig.formData.uploadInfo.push({
        posterType: fItem ? fItem.value : '',
        type: 1,
        url: '',
        file: [],
        base64Image: ''
      });
    };

    const deleteFormItem = index => {
      // console.log(index);
      formConfig.formData.uploadInfo.splice(index, 1);
    };

    const imgVisible = ref(false);
    const dialogImageUrl = ref('');

    const previewUploadImg = url => {
      // console.log(url);
      if (!url) return;
      dialogImageUrl.value = url;
      imgVisible.value = true;
    }; // 当前操作选图的图片索引


    const imgIndex = ref(0); // 打开图库

    const showPosterList = index => {
      imgIndex.value = index;
      posterObj.value.visible = true;
      posterObj.value.data = {
        sourceId: uploadImgParams.value.sourceId,
        programType: uploadImgParams.value.programType
      };
    }; // 图库选了图片


    const onInputImage = row => {
      formConfig.formData.uploadInfo[imgIndex.value].url = row[0].imageUrl;
    };

    watch(() => props.modelValue, val => {
      if (FormRef.value) {
        FormRef.value.mForm.clearValidate();
      }

      if (val) {
        if (props.formData.length) {
          formConfig.formData.uploadInfo = props.formData.map(m => {
            return { ...m,
              url: m.imgUrl,
              posterType: m.posterType || 'common',
              type: 0
            };
          });
        } else {
          formConfig.formData.uploadInfo = [{
            posterType: 'common',
            type: 1,
            url: '',
            file: [],
            base64Image: ''
          }];
        }
      }
    });
    watch(() => [...formConfig.formData.uploadInfo], val => {
      addDisabledForOptions(val);
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _component_MDialog = _resolveComponent("MDialog");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: __props.modelValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(modelValue) ? modelValue.value = $event : null),
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm,
        onOnClose: dialogConfig.cancel,
        nativeConfig: {
          closeOnClickModal: false
        }
      }, {
        default: _withCtx(() => [_createVNode(MultiFormTable, {
          ref_key: "FormRef",
          ref: FormRef,
          formRules: formConfig.rules,
          formData: formConfig.formData,
          propName: "uploadInfo",
          col: ['20%', '60%', '20%'],
          isInterval: false
        }, {
          default: _withCtx(({
            tableItem,
            tableIndex
          }) => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formList, (item, index) => {
            return _openBlock(), _createBlock(MultiFormItem, {
              key: index,
              "form-item": item,
              "form-data": formConfig.formData.uploadInfo[tableIndex],
              propIndex: tableIndex,
              propName: "uploadInfo"
            }, {
              itemSlot: _withCtx(scope => [scope.prop === 'posterType' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_select, {
                "fit-input-width": true,
                style: {
                  "width": "100%"
                },
                modelValue: formConfig.formData.uploadInfo[tableIndex].posterType,
                "onUpdate:modelValue": $event => formConfig.formData.uploadInfo[tableIndex].posterType = $event,
                disabled: formConfig.formData.uploadInfo[tableIndex].posterType == 'common'
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectOptions), (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: item.label,
                    value: item.value,
                    disabled: item.disabled
                  }, null, 8, ["label", "value", "disabled"]);
                }), 256))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])])) : _createCommentVNode("", true), scope.prop === 'type' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_el_checkbox, {
                "model-value": formConfig.formData.uploadInfo[tableIndex].type === 1,
                onChange: $event => handleCheckChange(1, tableIndex),
                label: _ctx.$t('上传图片'),
                size: "large"
              }, null, 8, ["model-value", "onChange", "label"]), _createVNode(_component_el_checkbox, {
                "model-value": formConfig.formData.uploadInfo[tableIndex].type === 0,
                onChange: $event => handleCheckChange(0, tableIndex),
                label: _ctx.$t('输入URL'),
                size: "large"
              }, null, 8, ["model-value", "onChange", "label"]), _createVNode(_component_el_checkbox, {
                "model-value": formConfig.formData.uploadInfo[tableIndex].type === 2,
                onChange: $event => handleCheckChange(2, tableIndex),
                label: _ctx.$t('图库'),
                size: "large"
              }, null, 8, ["model-value", "onChange", "label"])])])) : _createCommentVNode("", true), scope.prop === 'file' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [__props.modelValue ? (_openBlock(), _createBlock(ManuallyUpload, {
                key: 0,
                style: {
                  "width": "100%"
                },
                limit: __props.limit,
                cover: "",
                fileType: __props.fileType,
                accept: __props.accept,
                onHandleChange: file => fileChange(file, tableIndex),
                onHandelRemove: file => handelRemove(file, tableIndex)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  type: "primary",
                  plain: ""
                }, {
                  default: _withCtx(() => [_hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('点击上传')), 1)]),
                  _: 1
                })]),
                _: 2
              }, 1032, ["limit", "fileType", "accept", "onHandleChange", "onHandelRemove"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), scope.prop === 'url' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_input, {
                modelValue: formConfig.formData.uploadInfo[tableIndex].url,
                "onUpdate:modelValue": $event => formConfig.formData.uploadInfo[tableIndex].url = $event,
                placeholder: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_button, {
                type: "primary",
                onClick: $event => showPosterList(tableIndex)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('图库选图')), 1)]),
                _: 2
              }, 1032, ["onClick"])])) : _createCommentVNode("", true), scope.prop === 'uploadImage' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(MyLoadingImage, {
                class: "pointer",
                onClick: $event => previewUploadImg(tableItem.url ? tableItem.url : tableItem.base64Image),
                style: {
                  "width": "64px",
                  "height": "64px",
                  "border-radius": "6px"
                },
                src: tableItem.url ? tableItem.url : tableItem.base64Image,
                alt: ""
              }, null, 8, ["onClick", "src"]), tableIndex > 0 ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "pointer",
                onClick: $event => deleteFormItem(tableIndex),
                style: {
                  "display": "flex",
                  "justify-content": "center",
                  "align-items": "center",
                  "position": "absolute",
                  "bottom": "0",
                  "right": "0"
                }
              }, [_createElementVNode("img", {
                src: require('@/assets/imgs/ic_del.png'),
                alt: ""
              }, null, 8, _hoisted_10)], 8, _hoisted_9)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["form-item", "form-data", "propIndex"]);
          }), 128))]),
          _: 1
        }, 8, ["formRules", "formData"]), formConfig.formData.uploadInfo.length < posterTypeList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("span", {
          onClick: addFormItem,
          class: "pointer"
        }, "+")])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default"), _createVNode(_component_el_dialog, {
          modelValue: imgVisible.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => imgVisible.value = $event),
          closeOnClickModal: false,
          title: _ctx.$t('预览')
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", null, [_createElementVNode("img", {
            style: {
              "width": "100%",
              "height": "100%"
            },
            src: dialogImageUrl.value,
            alt: _ctx.$t('Preview Image')
          }, null, 8, _hoisted_13)])])]),
          _: 1
        }, 8, ["modelValue", "title"])]),
        _: 3
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm", "onOnClose"]), _createVNode(_unref(PosterList), {
        modelValue: posterObj.value.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => posterObj.value.visible = $event),
        data: posterObj.value.data,
        onInputImage: onInputImage
      }, null, 8, ["modelValue", "data"])], 64);
    };
  }

});